import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function ProtectedRoute({ children }) {
	const { user, loading } = useAuth();
	const navigate = useNavigate();
	const [isAuthenticated, setIsAuthenticated] = useState(null);

	useEffect(() => {
		if (!loading) {
			if (user) {
				setIsAuthenticated(true);
			} else {
				setIsAuthenticated(false);
				navigate("/login", { replace: true });
			}
		}
	}, [user, loading, navigate]);

	// Show loading while checking auth
	if (loading || isAuthenticated === null) {
		return (
			<div className="min-h-screen bg-background flex items-center justify-center">
				<div className="spinner"></div>
			</div>
		);
	}

	// Show children only when authenticated
	if (isAuthenticated) {
		return children;
	}

	return null;
}
